export const DrmProvider = {
  EzDrm: "ezdrm",
  Irdeto: "irdeto",
} as const

export type DrmProvider = typeof DrmProvider[keyof typeof DrmProvider]
